import { useMemo } from "react";

export const useGetActivitiesBySubTopic = (subTopicTask, currentAct = 0) => {
	const tasksList = useMemo(() => {
		let list = [];
		let points = { won: 0, total: 0 };
		let statusTopic = 0;
		let sumWonAux = 0;
		if (subTopicTask === undefined) {
			return { list, points, statusTopic };
		}
		const { task, points: pointsTotal } = subTopicTask;
		const taskList = task.map((t) => {
			let isComplete = t?.isComplete ?? false;
			let isCurrentAct = t.id === currentAct;
			sumWonAux += t.pointsWon;
			points.total += t.points;
			points.won += t.pointsWon;
			return { title: t.title, isComplete, isCurrentAct };
		});

		if (currentAct === 0) {
			statusTopic = sumWonAux === pointsTotal ? 2 : 1;
		}

		list = taskList;
		return { list, points, statusTopic };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [subTopicTask]);
	return {
		tasksList: tasksList.list,
		points: tasksList.points,
		statusTopic: tasksList.statusTopic,
	};
};
